var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c81ba;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.79,45.94V26.83c0-1.25.56-1.83,1.8-1.83q8.61,0,17.22,0a1.31,1.31,0,0,1,.84.34c4.15,4.12,8.29,8.27,12.43,12.4a1.22,1.22,0,0,1,.43.93c0,8.79,0,17.58,0,26.37a2.24,2.24,0,0,1-.15.94,1.54,1.54,0,0,1-1.55.86c-3.21,0-6.41,0-9.61,0H39.79c-1.5,0-2-.49-2-2ZM54.17,59.73H64.7c.72,0,.77,0,.77-.79,0-.51,0-1,0-1.54,0-.69-.06-.75-.76-.75H43.6c-.69,0-.78.09-.79.8v1.48c0,.73.08.8.78.8Zm.06-9.41h0c-3.56,0-7.13,0-10.69,0-.57,0-.75.21-.73.74s0,1,0,1.49c0,.77.08.85.85.85h21c.69,0,.76-.06.76-.74,0-.52,0-1,0-1.55,0-.74,0-.78-.77-.78Zm0-6.36H43.61c-.7,0-.79.09-.8.79,0,.51,0,1,0,1.54,0,.67.08.74.77.74H64.75c.56,0,.76-.19.73-.73s0-1,0-1.54c0-.77,0-.81-.81-.81ZM57.36,28.5v8.14c0,1.11.36,1.48,1.46,1.49h7.72a3,3,0,0,0,.4,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.19,70.1c0,1.24,0,2.38,0,3.52A1.45,1.45,0,0,1,60.57,75c-1.59,0-3.17,0-4.75,0H31.39a2.81,2.81,0,0,1-.29,0,1.51,1.51,0,0,1-1.6-1.67V46c0-3.66,0-7.32,0-11,0-1.38.52-1.91,1.89-1.91h3.11V67.49c0,.28,0,.57,0,.86a1.56,1.56,0,0,0,1.77,1.75c3.1,0,6.21,0,9.32,0h16.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons02);
export default __webpack_public_path__ + "static/media/Icons-02.a0dfe95733caa53a00686aedc392e94e.svg";
export { ForwardRef as ReactComponent };